module.exports = new __parcel__URL__("image-product-3-thumbnail.340480a5.jpg").toString();